import React, { Component } from "react";

import { Page, Breadcrumbs, Navigation } from "components";
import { Access } from "common";

class Main extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Professionais EAD", to: "" },
    ],
    navigation: [
      {
        name: "Clientes EAD",
        to: "/professionals/customers",
        hidden: !Access.hasPermissions([
          "view-customer-presential",
          "manage-customer-presential",
        ]),
      },
      {
        name: "Documentos",
        to: "/professionals/documents",
        hidden: !Access.hasPermissions(["manage-presencial-docs"]),
      },
    ],
  };

  render() {
    const { breadcrumbs, navigation } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Navigation items={navigation} />
      </Page>
    );
  }
}

export default Main;
